import React from 'react';
const Apps = (props) => <img className="tabLogo" src={props.src} width='20' height='20'
    style={{
        float: "left",
        display: 'block',
        margin: "5px 10px 0px 5px"
    }} />
export default Apps;